import Skeleton from "./Skeleton";
import SkeletonText from "./SkeletonText";

const SkeletonCard = () => {
  return (
    <div className="border border-black/10 p-2 space-y-2 ">
      <div className="flex items-center gap-3"> 
        <Skeleton className="w-full h-20" />
      </div>

      <Skeleton className="w-32 h-4" /> 
      <SkeletonText lines={2} />

      <div className="flex gap-2">
        <Skeleton className="w-full h-2" /> 
      </div>
    </div>
  );
};

export default SkeletonCard;